import React from 'react';
import { Box, Typography } from '@mui/material';
import Chart from 'react-apexcharts';
import { GreenDotIcon } from '../../../assets';
import { XEVINAPANT_COMPANY_ID } from '../../../constants';
import _ from 'lodash';
import { capitalizeFirstLetter } from '../../../utility';

const DonutChart = (props) => {
    const {
        chartOptions,
        chartSeries,
        data_test_id,
        companyId,
        chartName = '',
        isCount = false
    } = props;

    // ✅ Safe defaults
    const safeChartOptions = chartOptions ? _.cloneDeep(chartOptions) : {};
    const labels = safeChartOptions.labels || [];
    const colors = safeChartOptions.colors || [];
    const extraData = Array.isArray(safeChartOptions.extraData)
        ? safeChartOptions.extraData
        : [];

    // ✅ Only use valid numeric data, else empty array to trigger "noData"
    const hasValidData =
    Array.isArray(chartSeries) && chartSeries.some((v) => v > 0);
    const validSeries = hasValidData ? _.cloneDeep(chartSeries) : [];

    // ✅ Show (engaged/non_engaged) for Xevinapant company
    const showExtra = companyId === 67 && extraData.length > 0;

    return (
        <>
            {/* ✅ Donut Chart */}
            <Chart
                data-testid={data_test_id}
                height="auto"
                options={{
                    ...safeChartOptions,
                    legend: { show: false },
                    noData: {
                        text: 'No data to show',
                        align: 'center',
                        verticalAlign: 'middle',
                        style: { color: '#999', fontSize: '14px' }
                    }
                }}
                series={validSeries}
                type="donut"
                width="100%"
            />

            {/* ✅ Legend Section */}
            {hasValidData && (
                <Box
                    className={`flex-column-space-between mt-10px ${
                        companyId === XEVINAPANT_COMPANY_ID &&
            chartName === 'Physician Engagement by Specialty'
                            ? 'display_none'
                            : ''
                    }`}
                >
                    {chartSeries.map((value, index) => {
                        const label = labels[index] || 'N/A';
                        const color = colors[index] || '#ccc';
                        const engaged = extraData[index]?.engaged ?? null;
                        const nonEngaged = extraData[index]?.non_engaged ?? null;

                        return (
                            <Box className="flex-row-space-between" key={`${label}-${index}`}>
                                <Box className="flex-row-center gap-6">
                                    <GreenDotIcon color={color} />
                                    <Typography className="text-sm-regular gray-500">
                                        {capitalizeFirstLetter(label)}
                                    </Typography>
                                </Box>
                                <Typography className="text-sm-regular gray-500">
                                    {value ?? 0}
                                    {!isCount && '%'}
                                    {showExtra &&
                    engaged !== null &&
                    nonEngaged !== null && (
                                        <> ({engaged}/{nonEngaged})</>
                                    )}
                                </Typography>
                            </Box>
                        );
                    })}
                </Box>
            )}
        </>
    );
};

export default DonutChart;
